import { Dialog, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core'
import React, { useMemo } from 'react'
import TableHead from '@material-ui/core/TableHead'
import CheckBox from '@material-ui/core/Checkbox'
import { PopoverDraggable } from './popover-draggable'
import Tooltip from '@material-ui/core/Tooltip'
import { useDispatch } from 'react-redux'

export const RenvoieResultsPopper = ({
  open,
  setAnchorEl,
  renvoieResults = [],
  selectValues,
  currentRenvoieValues = [],
}) => {
  const dispatch = useDispatch()

  const dataHeaders = useMemo(() => {
    const headers = []
    console.log('ren', renvoieResults)
    renvoieResults.forEach(r => {
      console.log('r', r)
      r.data.forEach(d => {
        console.log('d', d)
        return !headers.includes(d.component) && headers.push(d.component)
      })
    })
    return headers
  }, [renvoieResults])
  const customDataHeaders = useMemo(() => {
    const headers = []
    renvoieResults.forEach(r => r.customData.forEach(d => !headers.includes(d.component) && headers.push(d.component)))
    return headers
  }, [renvoieResults])
  console.log('dateHeader', dataHeaders)
  console.log('customDataHeaders', customDataHeaders)

  function handleChooseLine(r) {
    console.log('renvoieResults choosen', r)
    selectValues(r)
  }

  const getChecked = r => {
    if (!currentRenvoieValues || !currentRenvoieValues.ids) return false
    return (
      r.customData.length === Object.keys(currentRenvoieValues.ids).length &&
      r.customData.every(cd => cd.id === currentRenvoieValues.ids[cd.component])
    )
  }
  return (
    <Dialog
      open={open}
      onClose={() => setAnchorEl(false)}
      PaperComponent={PopoverDraggable}
      aria-labelledby="draggable-dialog-title"
    >
      {open && (
        <TableContainer style={{ maxHeight: 500, width: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>ID</TableCell>
                {customDataHeaders.map(header => (
                  <TableCell key={header}>{header}</TableCell>
                ))}
                {dataHeaders.map(header => (
                  <TableCell key={header}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody style={{ maxHeight: 150, overflow: 'auto' }}>
              {renvoieResults.map(r => (
                <TableRow style={r.doublons.length ? { backgroundColor: '#e97070' } : {}}>
                  <TableCell>
                    <CheckBox
                      disabled={r.doublons.length}
                      onChange={() => handleChooseLine(currentRenvoieValues && getChecked(r) ? null : r)}
                      checked={getChecked(r)}
                    />
                  </TableCell>
                  {r.doublons.length ? (
                    <Tooltip
                      title={r.doublons.reduce((acc, curr) => (acc ? acc + ', ' : '') + curr, '')}
                      style={{ cursor: 'pointer' }}
                    >
                      <TableCell>{r.id}</TableCell>
                    </Tooltip>
                  ) : (
                    <TableCell>{r.id}</TableCell>
                  )}
                  {customDataHeaders.map(ch => (
                    <TableCell key={ch}>{r.customData.find(cd => cd.component === ch)?.value}</TableCell>
                  ))}
                  {dataHeaders.map(dh => (
                    <TableCell key={dh}>{r.data.find(cd => cd.component === dh)?.value}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Dialog>
  )
}
